import {
  get,
  options,
  destroyForm,
  post,
  patch,
  getPagination,
  getAllFetchProcessName,
  getFiltered,
} from "../../base";
import { getSingleFetchProcessName } from "../../base/utils";
import constants from "./constants";
import { store } from "../../store";
import { cloneDeep } from "lodash";

export const getAll = () => {
  return get({
    url: constants.LIST_URL,
    constants,
    name: getAllFetchProcessName(),
  });
};

export const getSingle = (id) => {
  const url = `${constants.GET_URL}${id}`;
  return get({ url, constants, name: getSingleFetchProcessName(id) });
};

export const performFilter = (
  querystring,
  callback,
  taskToken,
  initiatedBySocket
) => {
  const url = `${constants.LIST_URL}?${querystring}`;
  return getFiltered({
    url,
    constants,
    querystring,
    callback,
    taskToken,
    initiatedBySocket,
  });
};

export const filterPagination = (querystring) => {
  const url = `${constants.LIST_URL}?${querystring}`;
  return getPagination({ url, constants, querystring });
};

export const getPostForm = () => {
  return options({ url: constants.POST_URL, constants, method: "POST" });
};

export const destroyPostForm = (success) => {
  return destroyForm({ constants, method: "POST", success });
};

export const getPatchForm = (id) => {
  const url = `${constants.PATCH_URL}${id}`;
  return options({ url, constants, method: "PATCH" });
};

export const destroyPatchForm = (success) => {
  return destroyForm({ constants, method: "PATCH", success });
};

const complementedPreProcess = (data, preProcess) => {
  let cloned;
  if (preProcess) {
    cloned = preProcess(data);
  } else {
    cloned = cloneDeep(data);
  }

  // the rating file
  if (cloned?.errand_rating?.fileData_) {
    // file has been edited, editabledoc.doc has been set
    // so delete docData (on the clone, we have the reference on formInstance)
    delete cloned?.errand_rating?.fileData_;
  } else {
    // file has not been edited, don't send anything
    delete cloned?.errand_rating?.file;
  }

  // the images
  (cloned?.files || []).forEach((f) => {
    if (f) {
      // will never be sent to backend
      delete f._tempData;
      delete f.fileData_;
      delete f._referenceId;

      if (f.id) {
        // file has not been edited, so we can just use the id
        delete f?.file;
      }
    }
  });

  // cost files
  (cloned.costs || []).forEach((cf) => {
    if (cf?.evidence && !cf.evidenceData_) {
      delete cf.evidence;
    } else if (cf.evidenceData_) {
      delete cf.evidenceData_;
    }
  });

  return cloned;
};

const uploadCallback = async (responseData) => {
  const state = store.getState();
  const formInstance = state[constants.STORE_NAME].formInstance;

  return;
};

export const create = ({
  processSuccess,
  processError,
  successCallback,
  errorCallback,
  preProcess,
}) => {
  const fullPreProcess = (data) => complementedPreProcess(data, preProcess);

  return post({
    url: constants.POST_URL,
    constants,
    preProcess: fullPreProcess,
    processSuccess,
    processError,
    successCallback,
    uploadCallback: uploadCallback,
    errorCallback,
  });
};

export const update = ({
  id,
  processSuccess,
  processError,
  successCallback,
  errorCallback,
  preProcess,
  forceData,
  preventDefaultToast,
}) => {
  const url = `${constants.PATCH_URL}${id}`;
  const fullPreProcess = (data) => complementedPreProcess(data, preProcess);

  return patch({
    url,
    constants,
    preProcess: fullPreProcess,
    processSuccess,
    processError,
    successCallback,
    errorCallback,
    uploadCallback: uploadCallback,
    forceData,
    preventDefaultToast,
  });
};
